export default "__VITE_ASSET__bdc89aa1__"